import Button from "../Button";

// import background from "../../assets/home/subscribe-section/img01.png";
export default function SubscribeSection() {
  return (
    <>
      <div
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/img01.png"})`,
        }}
        className="flex flex-col bg-cover bg-slate-200 justify-center items-center h-96 mt-24 overflow-hidden "
      >
        <h3 className=" text-text font-fontOne font-bold text-3xl max-w-lg text-center mb-8">
          Get Latest Update By Subscribe Our Newsletter
        </h3>
        <Button color="pink">Subscribe Now</Button>
      </div>
    </>
  );
}
